<template>
    <el-container>
        <el-main>
            <el-card shadow="never">
                <el-tabs v-model="currModule" tab-position="top" @tab-change="tabChange">
                    <el-tab-pane v-for="(tab, index) in groupList" :key="index" :label="tab.title" :name="tab.module">
                        <div class="flex toolbar-btn-action">
                            <div class="btn-box">
                                <el-button type="primary" @click="topButAdd"><ui-icon type="add-select" /> 新增</el-button>
                            </div>
                        </div>
                        <el-tree class="tree-box" :data="menusList" node-key="id" default-expand-all :expand-on-click-node="false" :props="{ children: 'children', label: 'title', class: customNodeClass }">
                            <template #default="{ node, data }">
                                <div class="custom-tree-node">
                                    <div class="tree-label">
                                        <div class="title">
                                            <ui-icon v-if="data.icon" :type="data.icon" /> {{ node.label }}
                                        </div>
                                        <div>
                                            <template v-if="data.url_value">
                                                <ui-icon v-if="!data.is_auth" type="link" />
                                                <ui-icon v-else type="unlock" />
                                            </template>
                                            {{ data.url_value }}
                                        </div>
                                    </div>
                                    <div class="tree-node-but">
                                        <el-tooltip class="box-item" effect="dark" content="新增子节点" placement="top">
                                            <el-button text @click="nodeAdd(node, data)">
                                                <ui-icon class="el-menu-top-icon" type="add-select" />
                                            </el-button>
                                        </el-tooltip>
                                        <el-tooltip class="box-item" effect="dark" content="编辑" placement="top">
                                            <el-button text @click="nodeEdit(node, data)">
                                                <ui-icon class="el-menu-top-icon" type="editor1" />
                                            </el-button>
                                        </el-tooltip>
                                        <el-tooltip v-if="data.status" class="box-item" effect="dark" content="禁用" placement="top">
                                            <el-button text @click="nodeDisable(node, data)">
                                                <ui-icon class="el-menu-top-icon" type="block" />
                                            </el-button>
                                        </el-tooltip>
                                        <el-tooltip v-else class="box-item" effect="dark" content="启用" placement="top">
                                            <el-button text @click="nodeEnable(node, data)">
                                                <ui-icon class="el-menu-top-icon" type="success" />
                                            </el-button>
                                        </el-tooltip>
                                        <el-tooltip class="box-item" effect="dark" content="删除" placement="top">
                                            <el-button text @click="nodeDelete(node, data)">
                                                <ui-icon class="el-menu-top-icon" type="ashbin" />
                                            </el-button>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </template>
                        </el-tree>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-main>
    </el-container>
    <add ref="addFormRef" :title="formTitle" :urls="urls" @update:getDataList="getDataList" />
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, provide, reactive } from 'vue'
    import Add from '../../common/form'
    export default defineComponent({
        components: {
            Add
        },
        setup() {
            const { proxy } = getCurrentInstance()
            const addFormRef = ref()
            const formTitle = ref()
            const menusList = ref([])
            const currModule = ref('agency')
            const groupList = ref([])
            const urls = proxy.$router.currentRoute.value.meta.urls

            const getDataList = () => {
                proxy.jiu.request(urls.list, { group: currModule.value }).then((res, rej) => {
                    menusList.value = res.data.lists
                    groupList.value = res.data.group
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }
            const customNodeClass = (data, node) => {
                if (!data.status) {
                    return 'is-penultimate'
                }
                return null
            }

            const topButAdd = () => {
                formTitle.value = '新增节点'
                addFormRef.value.add({
                    'module': currModule.value
                })
            }

            const nodeAdd = (node, data) => {
                formTitle.value = '新增节点'
                addFormRef.value.add({
                    'module': data.module,
                    'id': data.id
                })
            }
            const nodeEdit = (node, data) => {
                formTitle.value = '编辑节点'
                addFormRef.value.edit({
                    'module': data.module,
                    'id': data.id
                })
            }
            const edit = (url, id) => {
                proxy.jiu.request(url, { id: id }).then((res, rej) => {
                    proxy.jiu.toast(res.message)
                    getDataList()
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }
            const nodeDisable = (node, data) => {
                proxy.jiu.modal('温馨提示', '您确定要执行此操作吗！！', true, (e) => {
                    if (e) {
                        edit(urls.disable, data.id)
                    }
                }, 'warning')
            }
            const nodeDelete = (node, data) => {
                proxy.jiu.modal('温馨提示', '您确定要执行此操作吗！！', true, (e) => {
                    if (e) {
                        edit(urls.delete, data.id)
                    }
                }, 'warning')
            }
            const nodeEnable = (node, data) => {
                proxy.jiu.modal('温馨提示', '您确定要执行此操作吗！！', true, (e) => {
                    if (e) {
                        edit(urls.enable, data.id)
                    }
                }, 'warning')
            }
            getDataList()
            const tabChange = (e) => {
                currModule.value = e
                menusList.value = []
                getDataList()
            }
            return {
                urls,
                currModule,
                menusList,
                groupList,
                formTitle,
                customNodeClass,

                topButAdd,
                nodeAdd,
                nodeEdit,
                nodeDisable,
                nodeDelete,
                nodeEnable,
                addFormRef,
                getDataList,

                tabChange
            }
        }
    })
</script>
<style>
    .tree-box .el-tree-node__content{
        height: auto;
    }
    .custom-tree-node{
        display: flex;
    }
    .tree-label{
        font-size: 14px;
        line-height: 2.3;
        display: flex;
    }
    .tree-label .title{
        margin-right: 10px;
        font-weight: bold;
    }
    .tree-node-but{
        margin-left: 20px;
    }
    .tree-node-but .el-button{
        padding: 0;
    }
    .el-tree-node__content .tree-node-but{
        display: none;
    }
    .el-tree-node__content:hover .tree-node-but{
        display: block;
    }
    .el-tree-node.is-expanded.is-penultimate .el-tree-node__content:hover,
    .el-tree-node.is-expanded.is-penultimate.is-current .el-tree-node__content,
    .el-tree-node.is-expanded.is-penultimate .el-tree-node__content{
        background: #FFD5D0;
        color: #D2847B;
    }
</style>
